import { render, staticRenderFns } from "./mijn-examenbundel.vue?vue&type=template&id=09aefc30"
import script from "./mijn-examenbundel.vue?vue&type=script&lang=js"
export * from "./mijn-examenbundel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports